var React = require('react');

function Toggle (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M6 7 0 0h12Z"}));
}

Toggle.defaultProps = {"width":"12","height":"7","data-name":"Layer 1","viewBox":"0 0 12 7"};

module.exports = Toggle;

Toggle.default = Toggle;
